/*
 * Express-Checkout im Cart-Drawer: nur PayPal.
 *
 * content_for_additional_checkout_buttons liefert alle aktiven Wallets (Shop
 * Pay, PayPal, Google Pay, Apple Pay ...) in einem festen Raster. Per CSS
 * ausblenden reicht nicht: die Spalten liegen im Shadow DOM, PayPal bliebe
 * ein Drittel breit. Deshalb wird <shopify-accelerated-checkout-cart> durch
 * eine Kopie ersetzt, deren wallet-configs nur noch PayPal enthaelt. Shopify
 * rendert dann genau einen Button ueber die volle Breite.
 *
 * Der Drawer-Inhalt kommt per innerHTML (Lazy-Fetch, siehe cart-drawer.js),
 * daher ein MutationObserver statt eines einmaligen Durchlaufs.
 */
(function () {
  const SELECTOR = '.mini-cart__express-checkout shopify-accelerated-checkout-cart';
  const checked = new WeakSet();

  function onlyPaypal(element) {
    if (checked.has(element)) return;
    checked.add(element);

    let configs;
    try {
      configs = JSON.parse(element.getAttribute('wallet-configs'));
    } catch (e) {
      return;
    }
    if (!Array.isArray(configs) || configs.every((config) => config.name === 'paypal')) return;

    const replacement = document.createElement(element.localName);
    for (const attribute of element.attributes) {
      replacement.setAttribute(attribute.name, attribute.value);
    }
    replacement.setAttribute('wallet-configs', JSON.stringify(configs.filter((config) => config.name === 'paypal')));
    element.replaceWith(replacement);
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(onlyPaypal);
  }

  function init() {
    const drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    scan();
    new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
